<h1>Races</h1>

<div *ngFor="let racePlan of racePlans$ | async" class="race-tile">
  <div>
    <h3>{{ racePlan.name }}</h3>
    <p>
      {{ racePlan.trackName }}, {{ racePlan.date | date:"dd.MM.y" }}
    </p>
  </div>
  <div>
    <!--<a [routerLink]="['/season/races', racePlan._id | toUntypedId, 'settings']"
      *ngIf="isModerable"
      class="btn btn-primary"
    >Settings</a>-->
    <a [routerLink]="['/season/races', racePlan._id | toUntypedId, 'rankings', 100]" class="btn btn-primary">Results &raquo;</a>
  </div>
</div>
